<template>
  <div v-if="showSupplementalTile" class="flex flex-col">
    <router-link
      :to="{
        name: 'supplemental-form',
        params: { applicationId: applicationId },
      }"
      class="flex flex-row justify-start items-center mb-2"
    >
      <CheckMarkIcon :completed="completed" />
      <p
        class="text-sm font-semibold ml-4 ml-4"
        :class="completed ? 'text-gray-650' : 'text-cyan-700'"
      >
        Supplemental Form
      </p>
    </router-link>
  </div>
</template>

<script>
import CheckMarkIcon from "@/components/forms/SharedComponents/CheckMarkIcon.vue";
import formIoApi from "@/mixins/formIoApi.js";
import postFormRules from "@/mixins/postFormRules.js";
import { eventBus } from "@/eventBus.js";
import { mapState } from "vuex";

export default {
  name: "SupplementalCard",
  components: { CheckMarkIcon },
  mixins: [formIoApi, postFormRules],
  data() {
    return {
      formURL: "supplementalform",
    };
  },
  computed: {
    ...mapState(["currentApplicationSubmissions"]),
    completed() {
      return Object.hasOwn(this.currentApplicationSubmissions, this.formURL);
    },
    applicationId() {
      return this.$route.params.applicationId;
    },
  },
  async mounted() {
    if (this.showSupplementalTile) {
      eventBus.$emit("addPreDepartureForm", {
        label: "Supplemental Form",
        ruleName: "Supplemental Form",
        routeName: "supplemental-form",
        submitted: this.completed,
      });
    }
  },
};
</script>
